import { ServiceRequestBase } from "../ServiceRequestBase";

export class SetLastAccessRequest extends ServiceRequestBase {
  public UserId: number | null = null;
}
